// extracted by mini-css-extract-plugin
export var AllergenIcon = "index-module--AllergenIcon--25318";
export var RTL = "index-module--RTL--73fd4";